<template>
  <section class="shell-section" style="padding-top: 28px; padding-bottom: 60px;">
    <div class="glass-surface static-info-card">
      <div class="section-heading" style="margin-bottom: 18px;">
        <span class="section-heading__eyebrow">Cuenta suspendida</span>
        <h2 class="section-heading__title">Tu acceso esta pausado temporalmente</h2>
        <p class="section-heading__text">
          Detectamos un problema con tu pago o con la validacion de tu cuenta. Puedes resolverlo rapido desde soporte y volver a comprar sin friccion.
        </p>
      </div>

      <div class="d-flex" style="gap: 14px; flex-wrap: wrap;">
        <a class="btn btn-primary" href="https://api.whatsapp.com/send?phone=593988959409&text=Hola%20quiero%20reactivar%20mi%20cuenta%20de%20Fomo%20Planes">Reactivar cuenta</a>
        <router-link class="btn btn-outline-light" :to="{ name: 'home' }">Volver al inicio</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DisabledAccount',
}
</script>
